import { render, staticRenderFns } from "./IssuedTaskItem.vue?vue&type=template&id=2eb5e898&scoped=true&"
import script from "./IssuedTaskItem.vue?vue&type=script&lang=js&"
export * from "./IssuedTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./IssuedTaskItem.vue?vue&type=style&index=0&id=2eb5e898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb5e898",
  null
  
)

export default component.exports